<template>
  <el-carousel
      class="zj-login-page-carousel"
      v-bind="carousel"
      :interval="THM('login.carousel.interval', 3000)">
      <el-carousel-item
        v-for="item in THM('login.carousel.imgs', [])"
        :key="item">
        <div
          class="zj-login-page-carousel-img"
          :style="'background-image: url(\''+item+'\')'"></div>
      </el-carousel-item>
    </el-carousel>
</template>

<script>
/** 登录页面自动切换背景图片 */
export default {
  name: 'ZjLoginCarousel',
  data() {
    return {
      carousel: {
        'initial-index': 0,
        height: '100%',
        trigger: 'click',
        autoplay: true,
        'indicator-position': '',
        arrow: 'never',
        loop: true,
        direction: 'horizontal'
      }
    };
  }
}
</script>
